const T = require("react").PropTypes;
const moment = require("moment");

const HistoricalFile = {
    Type: T.shape({
        PKID: T.number.isRequired,
        UploadTypeID: T.number.isRequired,
        UploadTypeName: T.string.isRequired,
        FileName: T.string.isRequired,
        Started: T.object.isRequired,
        Completed: T.object
    }),
    FromData(base) {
        const started = moment(base.Started);
        const completed = base.Completed ? moment(base.Completed) : null;
        
        const result = Object.assign({}, base, {
            Started: started,
            Completed: completed
        });

        return result;
    }
};

module.exports = HistoricalFile;


// WEBPACK FOOTER //
// ./src/types/HistoricalFile.js